export const STATIC_CLASSES = {
	root: 'video1',
	textContainer: 'video1-text-container',
	text: 'video1-text-block',
	videoContainer: 'video1-video-container',
	video: 'video1-video-block',
}
